/**
 * BookAttachmentCard — compact book card used inside posts/discussions.
 * Demonstrates the Community → Bookshelf connection (section 32).
 */

import React from 'react';
import { Link } from 'react-router-dom';
import { Plus } from 'lucide-react';
import { toast } from '@/components/ui/sonner';
import { bookHref } from '@/lib/bookModel';
import { resolveMockBookId } from '@/components/bookDetails/utils/resolveMockBookId';
import BookCoverArt from '@/components/books/BookCoverArt';

export default function BookAttachmentCard({ book }) {
  return (
    <div className="mt-3 flex items-center gap-3 rounded-xl border border-line bg-cream p-3">
      <Link to={bookHref(resolveMockBookId(book))} state={{ hint: book }} className="flex min-w-0 flex-1 items-center gap-3">
        <BookCoverArt book={book} className="h-14 w-10 shrink-0 shadow-card" />
        <div className="min-w-0 flex-1">
          <p className="truncate font-display text-sm font-semibold text-ink">{book.title}</p>
          <p className="truncate text-xs text-subtle">{book.author}</p>
        </div>
      </Link>
      <button
        type="button"
        onClick={() => toast(`Added “${book.title}” to your TBR`)}
        className="inline-flex shrink-0 items-center gap-1 rounded-full border border-line px-3 py-1.5 text-xs font-semibold text-ink transition-colors hover:border-coral/40 hover:text-coral"
      >
        <Plus className="h-3.5 w-3.5" /> Add to Bookshelf
      </button>
    </div>
  );
}
